import { isNil } from 'lodash';

/**
 * Sentinel for an `@Input()` whose parent has not finished resolving it.
 *
 * A two-state input cannot distinguish "still loading" from "resolved to
 * nothing", and those two cases often need opposite behaviour — a resolved
 * `undefined` is a final answer, while a pending value must keep dependent
 * behaviour gated. Parents emit it with `startWith(UNRESOLVED_INPUT)`; parents
 * with genuinely no value bind nothing and get the resolved default.
 *
 * `null` counts as unresolved because `AsyncPipe` binds `null` before its
 * source emits, so a parent that forgets `startWith` fails safe.
 */
export const UNRESOLVED_INPUT = 'unresolved';

export type Unresolved = typeof UNRESOLVED_INPUT;

export type UnresolvedOr<T> = T | Unresolved | undefined;

export function isResolved<T>(value: UnresolvedOr<T> | null): value is T {
  return !isNil(value) && value !== UNRESOLVED_INPUT;
}
